import { useCallback } from "react";
import { useCommand } from "@lookiero/messaging-react";
import { removeUiSetting } from "../../../../domain/uiSetting/command/removeUiSetting";
const useRemoveUiSetting = ({ contextId, logger }) => {
    const [commandBus, status] = useCommand({ contextId });
    const remove = useCallback(async ({ aggregateId }) => {
        try {
            await commandBus(removeUiSetting({ aggregateId }));
        }
        catch (error) {
            logger.captureException(error);
        }
    }, [commandBus, logger]);
    return [remove, status];
};
export { useRemoveUiSetting };
